import React, { Component } from "react";
import api from "../../config/api";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { amountDueComp, checkAllVincendoComp } from "../../actions"
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import logoPagueFacil from "../../assets/img/logo-pague-facil.svg";
import LoadingDefault from "../LoadingDefault";

const styles = theme => ({
    //Box azul com informações do usuário
    userInfo: {
        display: "flex",
        justifyContent: "space-between",
        background: "#1874B9",
        color: "#fff",
        marginTop: 36,
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column"
        },
        flexGrow: 1,
        position: 'fixed',
        top: 0,
        width: '100%',
        height: '100px',
        zIndex: 9,
    },
    welcomeUser: {
        padding: "10px 15px",
        display: "flex",
        alignItems: "center"
    },
    linkToHome: {
        textDecoration: "none",
        color: "inherit"
    },
    logoPagueFacil: {
        width: 100
    },
    messageTouser: {
        fontSize: 20,
        marginLeft: 30,
        maxWidth: '35ch',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        transition: 'all .2s',
        "&:hover": {
          transform: "scale(1.05)",
        }
    },
    userDebits: {
        display: "flex",
        alignItems: "center"
    },
    userDebitsItem: {
        padding: 20
    },
    userDebitsTitle: {
        margin: 0,
        fontSize: 26,
        transition: 'all .2s',
        "&:hover": {
          transform: "scale(1.05)",
        }
    },
    userSolicitacaoTitle: {
        margin: 0,
        fontSize: 26,
    },
    userDebitsText: {
        margin: 0,
        fontSize: 13
    },
    clickableDivVincendo: {
        cursor: 'pointer'
    },
    greenTitle: {
        color: '#3fff28'
    }
});

function handleGetShift() {
    const currentDate = new Date();
    const hour = currentDate.getHours();

    if (hour >= 0 && hour <= 4) {
        return "Boa madrugada";
    }
    if (hour >= 5 && hour <= 11) {
        return "Bom dia";
    } else if (hour >= 12 && hour <= 17) {
        return "Boa tarde";
    } else if ((hour >= 18 && hour <= 23) || hour === 0) {
        return "Boa noite";
    }
}

class HeaderManager extends Component {
    constructor(props) {
        super(props);
        // this.getAmountDebitsHeader = this.getAmountDebitsHeader.bind(this);
        this.getAmountIssuedDAMs = this.getAmountIssuedDAMs.bind(this);
        this.getAmountRequestedDAs = this.getAmountRequestedDAs.bind(this);

        this.state = {
            slide: 0,
            issuedDAMs: 0,
            DARequests: 0,
            issuedLoading: false,
            requestsLoading: false,
            issuedError: false,
            requestsError: false,
            userName: props.represented?.name,
        };
    }

    componentWillMount() {
        this.getAmountIssuedDAMs();
        this.getAmountRequestedDAs();
        this.props.checkAllVincendoComp(false)
    }

    componentDidMount = () => {
        window.addEventListener("scroll", this.handleScroll);
    };

    componentWillUnmount = () => {
        window.removeEventListener("scroll", this.handleScroll);
    };

    async getAmountIssuedDAMs() {
        if (this.props.amountDueValue === -1) {
            this.setState({
                issuedLoading: true,
            });

            try {
                let amountIssuedDams = await api.get("Gestao/ObterQtdDamGerados");                
                this.setState({
                    issuedDAMs: amountIssuedDams.data.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, "."),
                    issuedLoading: false
                }, () => {
                    //   this.props.amountDueComp(amountIssuedDams.data.Valor.toFixed(2)
                    //     .replace(".", ",")
                    //     .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."))
                });
            } catch (error) {
                this.setState({
                    issuedLoading: false,
                    issuedError: true
                });
            }
        }
    }

    async getAmountRequestedDAs() {
        this.setState({
            requestsLoading: true
        });

        try {
            let requestedDAs = await api.get("Gestao/ObterQtdDAGerados");
            this.setState({
                DARequests: requestedDAs.data,
                requestsLoading: false
            });
        } catch (error) {
            this.setState({
                requestsLoading: false,
                requestsError: true
            });
        }
    }

    handleScroll = () => {
        const { lastScrollY } = this.state;
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            this.setState({ slide: "-20px" });
        } else {
            this.setState({ slide: "0px" });
        }
        this.setState({ lastScrollY: currentScrollY });
    };

    handleCheckAllVincendo = () => {
        this.props.checkAllVincendoComp(!this.props.checkAllVincendoValue)
    };

    render() {
        const messageDay = handleGetShift();
        const {
            userName,
            issuedLoading,
            requestsLoading,
            issuedError,
            requestsError
        } = this.state;
        const { classes } = this.props;
        const contadorDamSingular = this.state.issuedDAMs === 1;
        const requisicaoDASingular = this.state.DARequests === 1;

        return (
            <div
                className={classes.userInfo}
                onScroll={this.handleScroll}
            // style={{
            //     transform: `translate(0, ${slide})`,
            //     transition: "transform 0.4s linear"
            // }}
            >
                <Link to="/" className={classes.linkToHome}>
                    <div className={classes.welcomeUser}>
                        <img
                            src={logoPagueFacil}
                            className={classes.logoPagueFacil}
                            alt="Logo PagueFácil"
                        />
                        <p className={classes.messageTouser}><span>{messageDay}, </span>{userName}!</p>
                    </div>
                </Link>

                <div className={classes.userDebits}>
                    <div
                        className={classes.userDebitsItem}
                        style={{ borderRight: "1px solid rgba(255, 255, 255, 0.32)" }}
                    >
                        {issuedLoading && (
                            <div className={classes.loadingDiv}>
                                <LoadingDefault typeLoading={"header"} />
                            </div>
                        )}

                        {!issuedLoading &&
                            <div>
                                {!issuedError ? (
                                    <div onClick={this.handleCheckAllVincendo} className={classes.clickableDivVincendo}>
                                        <p className={classes.userDebitsTitle}>
                                            {" "} <span className={classes.greenTitle}>{this.state.issuedDAMs}</span> {contadorDamSingular ? ('documento') : ('documentos')}
                                        </p>
                                        <p className={classes.userDebitsText}>
                                            {" "} {contadorDamSingular ? ('de arrecadação municipal emitido') : ('de arrecadação municipal emitidos')}
                                        </p>
                                    </div>
                                ) : (
                                        <p>Erro ao carregar dados.</p>
                                    )}
                            </div>
                        }

                    </div>

                    <div className={classes.userDebitsItem}>
                        {requestsLoading &&
                            <div className={classes.loadingDiv}>
                                <LoadingDefault typeLoading={"header"} />
                            </div>
                        }

                        {!requestsLoading &&
                            <div>
                                {!requestsError ? (
                                    <div>
                                        <p className={classes.userSolicitacaoTitle}>
                                            {" "} <span className={classes.greenTitle}>{this.state.DARequests}</span> {requisicaoDASingular ? ('solicitação') : ('solicitações')}
                                        </p>
                                        <p className={classes.userDebitsText}>
                                            {" "} {requisicaoDASingular ? ('de débito automático emitida') : ('de débito automático emitidas')}
                                        </p>
                                    </div>
                                ) : (
                                        <p>Erro ao carregar dados.</p>
                                    )}
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return {
    amountDueValue: store.cardDebitState.amountDueValue,
    checkAllVincendoValue: store.cardDebitState.checkAllVincendoValue,
    represented: store.auth.represented
}}

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        amountDueComp,
        checkAllVincendoComp
    }, dispatch);

export default withStyles(styles, { withTheme: true })(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(HeaderManager)
);
